var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"shueiJinJiouBanner",style:(`background-image: url(${_vm.bgImage})`)})
}
var staticRenderFns = []

export { render, staticRenderFns }